<template>
  <div class="transition-global totemBG tw-bg-cover tw-w-screen tw-h-screen">
    <vBtnReset />
    <!-- Mensagem Temporária -->
    <transition name="fade">
      <div
        v-if="mensagemTemporaria"
        class="tw-fixed tw-top-8 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-z-50 tw-px-8 tw-py-4 tw-rounded-2xl tw-shadow-2xl tw-text-white tw-text-2xl tw-font-bold tw-max-w-2xl tw-text-center"
        :class="{
          'tw-bg-green-600': mensagemTemporaria.tipo === 'sucesso',
          'tw-bg-red-600': mensagemTemporaria.tipo === 'erro',
          'tw-bg-blue-600': mensagemTemporaria.tipo === 'info',
        }"
      >
        {{ mensagemTemporaria.texto }}
      </div>
    </transition>
    <div class="tw-text-center">
      <vLogoDefault />
    </div>
    <div class="">
      <div class="tw-w-5/6 tw-p-8 tw-rounded-lg tw-mx-auto tw-my-auto">
        <div class="tw-py-8 tw-text-white tw-text-5xl tw-text-center tw-pt-0">
          Forma de pagamento
        </div>
        <!-- <div
          class="tw-text-4xl tw-tracking-wider tw-text-center tw-py-5 tw-text-white"
        >
          Selecione a forma de pagamento que deseja utilizar.
        </div> -->

        <!-- Resumo da Compra -->
        <div
          class="tw-bg-white tw-p-6 tw-rounded-2xl tw-shadow-lg tw-border-4 tw-my-6"
          style="
            border-color: #da1884;
            border-width: 3px;
            background-color: rgba(255, 255, 255, 0.6);
          "
        >
          <div class="tw-flex tw-justify-between tw-items-center">
            <!-- Esquerda -->
            <div class="tw-flex-1">
              <div class="tw-text-gray-600 tw-text-sm tw-font-semibold">
                Tamanho
              </div>
              <div class="tw-text-gray-800 tw-text-lg tw-font-bold">
                {{ getNomeTipoFoto }}
              </div>
              <div class="tw-text-gray-600 tw-text-sm tw-font-semibold tw-mt-3">
                Quantidade
              </div>
              <div class="tw-text-gray-800 tw-text-lg tw-font-bold">
                {{ getCOMPRA.qtde_foto }} und. {{ getPriceOriginal }}
              </div>
            </div>
            <!-- Divisor -->
            <div
              class="tw-mx-4 tw-h-32"
              style="border-left: 3px solid #da1884"
            ></div>
            <!-- Direita -->
            <div class="tw-flex-1 tw-text-left tw-ml-4">
              <div class="tw-text-gray-600 tw-text-sm tw-font-semibold">
                Cupom de desconto
              </div>
              <div class="tw-text-gray-800 tw-text-lg tw-font-bold">
                {{
                  getCOMPRA.cupom && getCOMPRA.cupom.desconto
                    ? formatarMoeda(getCOMPRA.cupom.desconto)
                    : "Sem cupom"
                }}
              </div>
              <div class="tw-text-gray-600 tw-text-sm tw-font-semibold tw-mt-3">
                Total:
              </div>
              <div class="tw-text-2xl tw-font-bold" style="color: #da1884">
                {{ getPrice }}
              </div>
            </div>
          </div>
        </div>

        <!-- Texto Cupom -->
        <div
          class="tw-text-3xl tw-tracking-wider tw-text-left tw-text-white tw-mt-4 tw-mb-4"
        >
          Possui cupom de desconto?
        </div>

        <!-- Input de Código de Cupom -->
        <div
          class="tw-mt-2 tw-bg-white tw-p-6 tw-rounded-2xl tw-shadow-lg tw-border-4"
          style="
            border-color: #da1884;
            border-width: 3px;
            background-color: rgba(255, 255, 255, 0.7);
          "
        >
          <div class="tw-flex tw-items-center tw-gap-3">
            <div class="tw-flex-1 tw-relative tw-flex tw-items-center">
              <input
                ref="inputCupom"
                v-model="codigoCupom"
                type="text"
                placeholder="Digite o código do cupom"
                maxlength="6"
                @click="focarInput"
                @input="
                  codigoCupom = $event.target.value
                    .replace(/[^0-9]/g, '')
                    .slice(0, 6)
                "
                class="tw-w-full tw-px-4 tw-py-1 tw-text-2xl tw-border-none tw-rounded-xl focus:tw-outline-none tw-text-gray-900 tw-bg-transparent"
              />
            </div>
          </div>
        </div>

        <!-- Keyboard Virtual -->
        <NumericKeyboard
          ref="refNumericKeyboardComponent"
          :value="codigoCupom"
          :mostrar="mostrarKeyboard"
          :inputRef="$refs.inputCupom"
          :aplicarAoEnter="aplicarCodigo"
          @input="codigoCupom = $event"
          @fechar="fecharKeyboard"
        />
        <!-- Botão Aplicar Cupom -->
        <div class="tw-mt-4 tw-flex tw-justify-end tw-mb-4">
          <button
            @click="aplicarCodigo"
            :disabled="!codigoCupom"
            class="tw-px-6 tw-py-2 tw-text-lg tw-font-bold tw-rounded-lg tw-transition-all"
            :class="
              codigoCupom
                ? 'btnAplicar tw-text-white hover:tw-opacity-90'
                : 'tw-bg-gray-300 tw-text-gray-500 tw-cursor-not-allowed'
            "
          >
            Aplicar
          </button>
        </div>

        <!-- Mensagem quando cupom zera o valor -->
        <transition name="fade">
          <div
            v-if="getCOMPRA.valor === 0"
            class="tw-bg-white tw-p-6 tw-rounded-2xl tw-shadow-lg tw-border-4 tw-mt-12 tw-text-center"
            style="
              border-color: #da1884;
              border-width: 3px;
              background-color: rgba(255, 255, 255, 0.6);
            "
          >
            <div
              class="tw-text-2xl tw-font-bold tw-mb-2"
              style="color: #da1884"
            >
              ✓ Parabéns!
            </div>
            <div class="tw-text-lg tw-text-gray-700 tw-mb-4">
              {{ getCOMPRA.cupom && getCOMPRA.cupom.id ? 'Seu cupom ofereceu desconto total.' : 'Este item é gratuito.' }}
            </div>
            <button
              @click="avancarPagamentoGratis"
              class="tw-px-8 tw-py-3 tw-text-lg tw-font-bold tw-rounded-lg tw-text-white hover:tw-opacity-90 tw-transition-all"
              style="background: #da1884"
            >
              Continuar
            </button>
          </div>
        </transition>

        <!-- Métodos de Pagamento - Ocultos quando cupom zera o valor -->
        <div v-if="getCOMPRA.valor > 0" class="tw-text-center">
          <div class="tw-pb-3">
            <div
              :key="index"
              v-for="(item, index) in getPaymentMethods"
              class="tw-py-4"
            >
              <button
                class="gradientItem tw-text-left tw-p-6 tw-px-8 tw-rounded-xl tw-text-white tw-text-5xl tw-w-full tw-mx-auto"
                :class="{
                  'tw-opacity-100': ItemSelecionado == item,
                  'tw-opacity-60': ItemSelecionado != item,
                }"
                @click="selectItem(item)"
              >
                <div class="tw-flex tw-items-center tw-gap-6">
                  <div class="tw-flex-shrink-0">
                    <svg
                      v-if="item.code == 'Credito' || item.code == 'Debito'"
                      xmlns="http://www.w3.org/2000/svg"
                      class="tw-h-16 tw-w-16"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                      />
                    </svg>
                    <div v-else-if="item.code == 'TAG'">
                      <v-icon color="white" size="60">mdi-cellphone-nfc</v-icon>
                    </div>
                    <div v-else>
                      <v-icon color="white" size="60">mdi-qrcode-scan</v-icon>
                    </div>
                  </div>
                  <div class="tw-text-4xl">
                    {{ item.name }}
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Sem botão "Voltar": o editor é remontado do zero ao retornar (carrega
           `url_original`), então voltar para EDICAO descartava silenciosamente
           todas as edições do cliente. O preview final já foi confirmado antes
           desta tela. -->
      <vTimeout
        v-if="getCOMPRA.etapa === $root.chapters().PAGAMENTO_SELECT"
        :segundos="$root.getTimeoutName($root.chapters().PAGAMENTO_SELECT)"
      />
    </div>
  </div>
</template>

<script>
import { getList as getTiposFoto } from "@/constants/tipoFoto.js";
import { getMethodForCode } from "@/constants/types/PaymentMethods.js";
import {
  buscarCupomPrivado,
  setEtapaCompra,
  updateCompraInterface,
  incrementarUsosCupom,
} from "@/service/firebase.js";
import anime from "animejs";
import NumericKeyboard from "../../../components/NumericKeyboard.vue";
import vBtnReset from "@/components/vBtnReset.vue";
import posthog from "@/posthog";
import { registrarCompraGratuita } from "@/service/purchasePayment";

export default {
  components: {
    NumericKeyboard,
    vBtnReset,
  },
  data() {
    return {
      ItemSelecionado: {},
      codigoCupom: "",
      mostrarKeyboard: false,
      mensagemTemporaria: null,
    };
  },
  mounted() {
    this.animaMounted();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove o listener para evitar memory leaks
    document.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    getPaymentMethods() {
      let paymentMethods = [];
      let cabineConfig = this.$store.getters["totem/getTotem"].config;

      // Totem MultiClubes só disponibiliza o pagamento por TAG (MultiClubes).
      if (cabineConfig.multiclubes) {
        return [getMethodForCode("TAG")];
      }

      if (cabineConfig.pagamento_cartao_credito) {
        let includePayment = getMethodForCode("Credito");
        paymentMethods.push(includePayment);
      }
      if (cabineConfig.pagamento_cartao_debito) {
        let includePayment = getMethodForCode("Debito");
        paymentMethods.push(includePayment);
      }
      if (cabineConfig.pagamento_pix) {
        let includePayment = getMethodForCode("PIX");
        paymentMethods.push(includePayment);
      }
      if (cabineConfig.pagamento_multiclubes) {
        let includePayment = getMethodForCode("TAG");
        paymentMethods.push(includePayment);
      }

      return paymentMethods;
    },
    getPrice() {
      let valor = this.getCOMPRA.valor;
      // Garante que o valor nunca seja negativo
      valor = Math.max(valor, 0);
      let currency = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
      return currency;
    },
    getPriceOriginal() {
      // Retorna o valor original antes do desconto
      // Se houver cupom aplicado, usa valor_original, senão usa valor atual
      let valor = this.getCOMPRA.cupom?.valor_original || this.getCOMPRA.valor;
      valor = Math.max(valor, 0);
      let currency = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
      return currency;
    },
    getCOMPRA() {
      return this.$store.getters["compra/getCompra"];
    },
    getDescontoAplicado() {
      const compra = this.getCOMPRA;
      if (
        compra.valor_desconto_original &&
        compra.valor_desconto !== undefined
      ) {
        return compra.valor_desconto_original - compra.valor_desconto;
      }
      return 0;
    },
    getNomeTipoFoto() {
      const tipoFoto = this.getCOMPRA.tipo_foto;
      if (!tipoFoto) return "";

      const tiposFoto = getTiposFoto();
      const fotoEncontrada = tiposFoto.find((foto) => foto.id === tipoFoto);

      return fotoEncontrada ? fotoEncontrada.nome : tipoFoto;
    },
  },
  methods: {
    handleClickOutside(event) {
      const keyboard = this.$refs.refNumericKeyboardComponent;
      const input = this.$refs.inputCupom;

      if (
        keyboard &&
        !keyboard.$el.contains(event.target) &&
        !(input && input.contains(event.target))
      ) {
        this.mostrarKeyboard = false;
      }
    },
    mostrarMensagem(texto, tipo = "info") {
      this.mensagemTemporaria = { texto, tipo };
      setTimeout(() => {
        this.mensagemTemporaria = null;
      }, 5000);
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
    },
    /* FUNÇÃO NÃO UTILIZADA - REGRA DE PULAR PAGAMENTO
    async validaRegraNoPain() {
      const requirePain =
        this.$store.getters["totem/getTotem"].config.pular_etapa_pagamento;
      const precoAPagar = this.$store.getters["compra/getCompra"].valor;
      if (requirePain || precoAPagar == 0) {
        console.log("REGRA SEM PAGAR");
        let compra_atual = this.$store.getters["compra/getCompra"];
        compra_atual.pago = false;
        compra_atual.etapa = "IMPRESSAO";
        await updateCompraInterface(compra_atual);
        setEtapaCompra("IMPRESSAO");
      } else {
        console.log("REGRA PAGAR ");
        let compra_atual = this.$store.getters["compra/getCompra"];
        compra_atual.pago = true;
        await updateCompraInterface(compra_atual);
      }
    },*/
    async selectItem(item) {
      try {
        const salvo = await this.selecionaMetodoDePagamento(item?.code);
        if (!salvo) return;
      } catch {
        this.$root.infoModal("Não foi possível salvar a forma de pagamento. Tente novamente.");
        return;
      }
      this.ItemSelecionado = item;
      await setEtapaCompra(this.$root.chapters().PAGAMENTO_PROCESSO);
      posthog.capture("payment_method_selected", {
        payment_method: item.code,
      });
    },
    async selecionaMetodoDePagamento(metodo) {
      if (
        metodo == "Debito" ||
        metodo == "Credito" ||
        metodo == "PIX" ||
        metodo == "TAG"
      ) {
        let compraAtual = this.$store.getters["compra/getCompra"];
        compraAtual.tipoCartao = metodo;
        await updateCompraInterface(compraAtual);
        return true;
      } else {
        this.$root.infoModal("Método de pagamento não encontrado.");
        return false;
      }
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 1000,
          easing: "easeInOutExpo",
        },
      });
    },
    focarInput() {
      this.mostrarKeyboard = true;
    },
    fecharKeyboard() {
      this.mostrarKeyboard = false;
    },
    validarDiaSemana(diasSemana) {
      if (
        !diasSemana ||
        !Array.isArray(diasSemana) ||
        diasSemana.length === 0
      ) {
        return false;
      }

      const diasMap = {
        0: "dom",
        1: "seg",
        2: "ter",
        3: "qua",
        4: "qui",
        5: "sex",
        6: "sab",
      };

      const hoje = new Date();
      const diaHoje = diasMap[hoje.getDay()];

      return diasSemana.includes(diaHoje);
    },
    async aplicarCodigo() {
      if (!this.codigoCupom) return;

      const codigoFormatado = this.codigoCupom.trim().toUpperCase();

      try {
        const resultado = await buscarCupomPrivado(codigoFormatado);

        if (resultado.sucesso) {
          if (
            resultado.cupom.diasSemana &&
            !this.validarDiaSemana(resultado.cupom.diasSemana)
          ) {
            this.mostrarMensagem("Cupom inválido", "erro");
            this.codigoCupom = "";
            return;
          }

          let compraAtual = this.$store.getters["compra/getCompra"];

          if (compraAtual.valor.toFixed(2) < resultado.cupom.valorMinimo) {
            this.mostrarMensagem("Valor mínimo não atingido", "erro");
            this.codigoCupom = "";
            return;
          }

          const valorOriginal =
            compraAtual.cupom?.valor_original || compraAtual.valor;

          let valorDesconto = 0;
          if (resultado.cupom.tipoDesconto === "FIXO") {
            valorDesconto = resultado.cupom.valorDesconto;
          } else if (resultado.cupom.tipoDesconto === "PERCENTUAL") {
            valorDesconto =
              (valorOriginal * resultado.cupom.valorDesconto) / 100;
          }

          if (valorDesconto > valorOriginal) {
            valorDesconto = valorOriginal;
          }

          const valorFinal = Math.max(valorOriginal - valorDesconto, 0);

          compraAtual.valor = valorFinal;
          compraAtual.cupom = {
            codigo: resultado.cupom.codigo,
            id: resultado.cupom.id,
            valor_original: valorOriginal,
            desconto: valorDesconto,
            desconto_tipo: resultado.cupom.tipoDesconto,
          };

          this.$store.commit("compra/setCompra", compraAtual);
          await updateCompraInterface(compraAtual);

          this.codigoCupom = "";
          this.fecharKeyboard();
          posthog.capture("coupon_applied", {
            discount_type: resultado.cupom.tipoDesconto,
            discount_value: valorDesconto,
          });
          this.mostrarMensagem("✓ Cupom aplicado com sucesso!", "sucesso");
        } else {
          this.mostrarMensagem(resultado.mensagem, "erro");
          this.codigoCupom = "";
        }
      } catch (error) {
        console.error("Erro ao validar cupom:", error);
        this.mostrarMensagem("Erro ao validar o cupom", "erro");
        this.codigoCupom = "";
      }
    },
    async avancarPagamentoGratis() {
      const compra = this.getCOMPRA;
      try {
        if (compra.cupom && compra.cupom.id) {
          await incrementarUsosCupom(compra.cupom.id);
        }
        registrarCompraGratuita(compra);
        this.$store.commit("compra/setCompra", compra);
        await updateCompraInterface(compra);
        posthog.capture("payment_completed", {
          payment_method: "complimentary",
          purchase_value: compra.valor,
        });
        setEtapaCompra(this.$root.chapters().PAGAMENTO_SUCESSO);
      } catch (error) {
        console.error("Erro ao processar pagamento grátis:", error);
        this.mostrarMensagem("Erro ao processar cupom grátis", "erro");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btnActionCard {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr;
  @apply tw-bg-white tw-group tw-rounded-md tw-justify-center tw-items-center tw-shadow-lg tw-mx-auto tw-w-full tw-border-2 tw-border-solid tw-border-gray-300 tw-p-6 tw-text-gray-700 tw-font-bold tw-text-xl tw-tracking-wide focus:tw-bg-indigo-700 hover:tw-bg-indigo-700 hover:tw-text-white focus:tw-text-white;
}

.gradientItem {
  background: linear-gradient(180deg, #8876a1 0%, #222129 100%);
}

.totemBG {
  background-size: cover;
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../../assets/fundo.png");
}

.transition-global {
  opacity: 0;
}

.header-text {
  color: #3d5a80;
  font-size: 28px;
  line-height: 29px;
}

.textBody {
  color: #4a4a4a;
  font-family: "Roboto", sans-serif;
}

.btnAplicar {
  background: #da1884;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
